import React, {   } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';




export const HotkeysHook = (props) => { 
    useHotkeys('ctrl+f', () =>{
       const _WaveformView = props.WaveformView;
        _WaveformView.setIsShowFindAllViewInput();  

        setTimeout(() => {
          var divObj = document.getElementById('FindAllView_input'); 
          var inputs = divObj.getElementsByTagName('input'); 
          inputs[0].focus(); 

          for (var i = 0; i < inputs.length; i++) {
            inputs[i].focus(); 

            inputs[i].addEventListener("keypress", function(event) {
              // If the user presses the "Enter" key on the keyboard
              if (event.key === "Enter") {
                // Cancel the default action, if needed
                event.preventDefault();
                // Trigger the button element with a click
                document.getElementById("findAll_btn").click();
              }
            });

          }


        }, 100);
    });
     
    useHotkeys('ctrl+shift+left', () =>{
      // 左移 1 f 
      const _WaveformView = props.WaveformView;
      _WaveformView.player.replay(1/_WaveformView.videoFps);
      console.log(1/_WaveformView.videoFps ); 
// forward
       
   }); 
   useHotkeys('ctrl+shift+right', () =>{
    // 右移 1 f
      const _WaveformView = props.WaveformView;
      _WaveformView.player.forward(1/_WaveformView.videoFps);
      console.log(1/_WaveformView.videoFps ); 
      
  }); 
    useHotkeys('ctrl+shift+d', () =>{
       const _WaveformView = props.WaveformView; 
       _WaveformView.mutile_delete_Row();
    }); 
    useHotkeys('ctrl+down', () =>{
       // this.Play_From_Selected_Row()
        const _WaveformView = props.WaveformView; 
        const isPlayerStartData = _WaveformView.props.context.isPlayerStart;
        if (isPlayerStartData.isPlay === true) {
            _WaveformView.pause();
        } else {
            _WaveformView.play();
        }
    }); 
 
    useHotkeys('alt+m', () =>{
      console.log('alt+m') 
        
   }); 
    useHotkeys('shift+space', () =>{ 
        const _WaveformView = props.WaveformView; 
        // console.log('shift+space : ' + _WaveformView.isPlay )
        if(parseInt(localStorage.getItem('PlayPauseHoykey')) === 0){
          if (_WaveformView.isPlay === true) {
            _WaveformView.pause();
          } else {
            _WaveformView.play();
          }
        }  
   }); 

   useHotkeys('ctrl+space', () =>{ 
      console.log('ctrl+space')
        const _WaveformView = props.WaveformView; 

        if(parseInt(localStorage.getItem('PlayFromSelectedRow')) === 0){  

          _WaveformView.ITManPlayer_play(_WaveformView.blue_row); //控制回傳'
        } 
   }); 

 
    return (
      <div> 
        {props.children}
      </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/drogable/HotkeysHook.js